var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#e6007e;}.b,.c{fill-rule:evenodd;}.c{fill:#e6007e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(1)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13,.628,3.166,8.1a.5.5,0,0,0,.3.9H4.976l.476,9.525a.5.5,0,0,0,.5.475h14.1a.5.5,0,0,0,.5-.475L21.024,9h1.507a.5.5,0,0,0,.3-.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.5,14.5h5a.5.5,0,0,1,0,1h-5a.5.5,0,0,1,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M4,.5a.4.4,0,0,1,.4.4V5l.99.619a2,2,0,0,1,.837,1.064L7,9H8c0,2-1.5,4.5-4,4.5S0,11,0,9H1l.773-2.318A2,2,0,0,1,2.61,5.619L3.6,5V.9A.4.4,0,0,1,4,.5ZM4,6l-.138.006a1.477,1.477,0,0,0-1.233.922h0L2,8.5,4,8l2,.5L5.371,6.928A1.477,1.477,0,0,0,4,6Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.d0dc30fe4107a58bbf5de770e3b4a7ca.svg";
export { ForwardRef as ReactComponent };